import { useId } from "react";
import { Box } from "@mui/material";
import VuiTypography from "components/ui/VuiTypography";

const SIZE_MAP = { sm: 40, md: 60, lg: 80 };

const ThinkingAnimation = ({ size = "md", message = null, containerHeight = null }) => {
  const uid = useId();
  const gradientId = `thinkingIconGradient-${uid.replace(/:/g, "")}`;
  const dim = SIZE_MAP[size] ?? SIZE_MAP.md;

  const containerSx = {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    ...(containerHeight != null
      ? containerHeight === "100%" || containerHeight === "100"
        ? { height: "100%", minHeight: "100%" }
        : { minHeight: containerHeight }
      : {}),
  };

  return (
    <Box sx={containerSx}>
      <Box
        sx={{
          width: dim,
          height: dim,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          mb: message ? "24px" : 0,
        }}
      >
        <svg
          viewBox="0 0 100 100"
          xmlns="http://www.w3.org/2000/svg"
          width={dim}
          height={dim}
        >
          <defs>
            <linearGradient id={gradientId} x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" style={{ stopColor: "#A78BFA", stopOpacity: 1 }} />
              <stop offset="100%" style={{ stopColor: "#FFFFFF", stopOpacity: 1 }} />
            </linearGradient>
          </defs>
          <g>
            <g>
              <line x1="50" y1="50" x2="50" y2="15" stroke="rgba(255,255,255,0.5)" strokeWidth="2.5" />
              <animateTransform attributeName="transform" type="rotate" from="0 50 50" to="360 50 50" dur="8s" repeatCount="indefinite" />
            </g>
            <g>
              <line x1="50" y1="50" x2="20" y2="35" stroke="rgba(255,255,255,0.5)" strokeWidth="2.5" />
              <animateTransform attributeName="transform" type="rotate" from="0 50 50" to="-360 50 50" dur="10s" repeatCount="indefinite" />
            </g>
            <g>
              <line x1="50" y1="50" x2="80" y2="65" stroke="rgba(255,255,255,0.5)" strokeWidth="2.5" />
              <animateTransform attributeName="transform" type="rotate" from="360 50 50" to="0 50 50" dur="6s" repeatCount="indefinite" />
            </g>
            <circle cx="50" cy="50" r="18" fill={`url(#${gradientId})`} />
            <g>
              <circle cx="50" cy="15" r="10" fill={`url(#${gradientId})`} />
              <animateTransform attributeName="transform" type="rotate" from="0 50 50" to="360 50 50" dur="8s" repeatCount="indefinite" />
            </g>
            <g>
              <circle cx="20" cy="35" r="8" fill={`url(#${gradientId})`} />
              <animateTransform attributeName="transform" type="rotate" from="0 50 50" to="-360 50 50" dur="10s" repeatCount="indefinite" />
            </g>
            <g>
              <circle cx="80" cy="65" r="9" fill={`url(#${gradientId})`} />
              <animateTransform attributeName="transform" type="rotate" from="360 50 50" to="0 50 50" dur="6s" repeatCount="indefinite" />
            </g>
          </g>
        </svg>
      </Box>
      {message && (
        <VuiTypography variant="h6" color="white" fontWeight="regular">
          {message}
        </VuiTypography>
      )}
    </Box>
  );
};

export default ThinkingAnimation;
